import {Icon} from "components"
import {QRCodeSVG} from "qrcode.react"
import styles from "./QRScan.module.css"
import {AttendanceEventType} from "types/attendance"
import {useEffect, useState} from "react"
import cx from "classnames"
import {useInterval} from "react-use"
import {Checkbox} from "antd"
import {useGetGeolocation, useTOPT} from "hooks"
import {useEdularModulesContext, Modules} from "@edular/modules"
import {MakeupAttendanceType} from "../EditMakeupAttendance/EditMakeupAttendance"

type Props = {
    selectedAttendance?: MakeupAttendanceType
    showAsStandalone?: boolean
}

export const QRScan = (props: Props) => {
    const {selectedAttendance, showAsStandalone = false} = props
    const [currentEventType, setCurrentEventType] = useState<AttendanceEventType>(AttendanceEventType.BreakStart)
    const getOtp = useTOPT()
    const [qrCode, setQrCode] = useState<string>(undefined)
    const [totp, setTOtp] = useState<string>()
    const [countDown, setCountdown] = useState(-1)
    const [locationEnabled, setLocationEnabled] = useState(true)
    const [geoLocation, setGeoLocation] = useState<GeolocationPosition>(null)
    const {isModuleEnable} = useEdularModulesContext()
    const isEnableTrackingAttendanceModule = isModuleEnable(Modules.AcademicLocationTrackingAttendance)
    const {getGeolocation} = useGetGeolocation({
        onSuccess: (position) => setGeoLocation(position),
        onError: (error) => console.log(error)
    })

    useEffect(() => {
        if (navigator.geolocation && isEnableTrackingAttendanceModule) {
            getGeolocation()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useInterval(() => {
        const {otp, timeLeft} = getOtp()
        setTOtp(otp)
        setCountdown(timeLeft)
    }, 1000)

    useEffect(() => {
        if (totp) {
            const qrData = {
                isMakeup: true,
                token: totp,
                eventType: selectedAttendance ? currentEventType : AttendanceEventType.Checkin,
                academicMakeupStudentId: selectedAttendance?.academicMakeupStudentId,
                studentProfileId: selectedAttendance?.studentProfileId,
                comments: "Makeup Attendance",
                latitude: locationEnabled ? geoLocation?.coords?.latitude : undefined,
                longitude: locationEnabled ? geoLocation?.coords?.longitude : undefined
            }
            setQrCode(JSON.stringify(qrData))
        }
    }, [totp, selectedAttendance, currentEventType, locationEnabled, geoLocation])

    return (
        <>
            {selectedAttendance ? (
                <>
                    <div className={styles.actions}>
                        <div
                            className={cx(styles.buttonAction, {
                                [styles.active]: [
                                    AttendanceEventType.BreakStart,
                                    AttendanceEventType.BreakEnd
                                ].includes(currentEventType)
                            })}
                            onClick={() => setCurrentEventType(AttendanceEventType.BreakStart)}>
                            <Icon icon="ATTENDANCE_IN" className={styles.eventIcon} color={"#1e90ff"} />
                            <span className={styles.buttonText}>BREAK</span>
                        </div>
                        <div
                            className={cx(styles.buttonAction, {
                                [styles.active]: currentEventType === AttendanceEventType.Checkout
                            })}
                            onClick={() => setCurrentEventType(AttendanceEventType.Checkout)}>
                            <span className={styles.buttonText}>CHECKOUT</span>
                            <Icon icon="CHECKOUT_FILL" className={styles.eventIcon} color={"#1e90ff"} />
                        </div>
                    </div>
                </>
            ) : null}
            <div className={cx(styles.content, {[styles.standaloneContent]: showAsStandalone})}>
                <div className={styles.qrInfoWrap}>
                    <span className={styles.detail}>
                        {selectedAttendance ? "SCAN QR ON YOUR DEVICE" : "SCAN QR ON YOUR DEVICE TO CHECKIN"}
                    </span>
                    <span className={styles.countDownText}>{countDown >= 0 ? countDown : ""}</span>
                </div>
                <QRCodeSVG width={280} height={280} value={qrCode} />
                {isEnableTrackingAttendanceModule && (
                    <Checkbox checked={locationEnabled} onChange={(event) => setLocationEnabled(event.target.checked)}>
                        Location Attendance enabled
                    </Checkbox>
                )}
            </div>
        </>
    )
}
